import { createAction } from '@reduxjs/toolkit';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';

export class UpdateMessageSuccess {
  static get action() {
    return createAction('broadcastMessages/UPDATE_MESSAGE_SUCCESS');
  }

  static get reducer() {
    return (draft: IBroadcastMessagesState) => {
      draft.requests.updateBroadcastMessagePending = false;

      return draft;
    };
  }
}
